import {all, fork, put, call, takeEvery, takeLatest, delay} from "redux-saga/effects"
import {
  SEARCH_GUEST_PREVIEW,
  SEARCH_GUEST_DETAIL_REQUEST,
  GET_GUEST,
  UPDATE_GUEST_REQUEST,
  CREATE_GUEST_REQUEST,
  MERGE_GUEST_REQUEST
} from "constants/ActionTypes"

import {searchGuestDataSourceSuccess,
        getGuestProcessSuccess, 
        getMainGuest, 
        setMsgAlertBooking,

        searchGuestDetailDataSourceSuccess,
        searchGuestDetailFormDataSourceSuccess,
        searchGuestProcessSuccess,
        updateGuestSuccess,
        updateGuestFailure,
        createGuestSuccess,
        createGuestFailure,
        mergeGuestSuccess,
        mergeGuestFailure
      } from "appRedux/actions/Guest"
import {userSignOut} from "appRedux/actions/Auth" //showAuthMessage

import { APIGetRequest, APIPostRequest } from "util/connection"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import { isEmpty } from "lodash"
import { getItems } from "util/localStorage"

function* guestSearchProcess({payload}) {
  let keywords = payload || {}
  const guestInfo = {}

  // Helper to support both camelCase and snake_case inputs
  const get = (camel, snake) => {
    if (keywords[camel] !== undefined && keywords[camel] !== null && keywords[camel] !== '') return keywords[camel]
    if (keywords[snake] !== undefined && keywords[snake] !== null && keywords[snake] !== '') return keywords[snake]
    return undefined
  }

  // ===== Backward-compatible mappings (existing keys) =====
  if (get('id', 'id') !== undefined) guestInfo.id = get('id', 'id')
  if (get('name', 'guest_name') !== undefined) guestInfo.guest_name = get('name', 'guest_name')
  if (get('documentNumber', 'doc_number') !== undefined) guestInfo.doc_number = get('documentNumber', 'doc_number')
  if (get('memberCode', 'member_code') !== undefined) guestInfo.member_code = get('memberCode', 'member_code')
  if (get('email', 'email') !== undefined) guestInfo.email = get('email', 'email')
  if (get('telephone', 'telephone') !== undefined) guestInfo.telephone = get('telephone', 'telephone')
  if (get('nationId', 'nation_id') !== undefined) guestInfo.nation_id = get('nationId', 'nation_id')
  if (get('page', 'page') !== undefined) guestInfo.page = get('page', 'page')
  if (get('limit', 'limit') !== undefined) guestInfo.limit = get('limit', 'limit')

  // ===== New Guest History search mappings (support camel & snake) =====
  if (get('searchText', 'search_text') !== undefined) guestInfo.search_text = get('searchText', 'search_text')
  if (get('arrival', 'arrival') !== undefined) guestInfo.arrival = get('arrival', 'arrival')
  if (get('departure', 'departure') !== undefined) guestInfo.departure = get('departure', 'departure')
  if (get('stayDate', 'stay_date') !== undefined) guestInfo.stay_date = get('stayDate', 'stay_date')

  if (get('vipId', 'vip_id') !== undefined) guestInfo.vip_id = get('vipId', 'vip_id')
  if (get('channelName', 'channel_id') !== undefined) guestInfo.channel_id = get('channelName', 'channel_id')

  if (get('company', 'company') !== undefined) guestInfo.company = get('company', 'company')
  if (get('country', 'country_id') !== undefined) guestInfo.country_id = get('country', 'country_id')

  if (get('birthDate', 'birthdate') !== undefined) guestInfo.birthdate = get('birthDate', 'birthdate')
  if (get('visitTime', 'visit_time') !== undefined) guestInfo.visit_time = get('visitTime', 'visit_time')
  if (get('carplateNo', 'carplate_no') !== undefined) guestInfo.carplate_no = get('carplateNo', 'carplate_no')
  if (get('registerId', 'register_id') !== undefined) guestInfo.register_id = get('registerId', 'register_id')
  if (get('bookingId', 'booking_id') !== undefined) guestInfo.booking_id = get('bookingId', 'booking_id')
  if (get('roomNumber', 'room_number') !== undefined) guestInfo.room_number = get('roomNumber', 'room_number')
  if (get('roomTypeId', 'roomtype_id') !== undefined) guestInfo.roomtype_id = get('roomTypeId', 'roomtype_id')
  if (get('ratePlanId', 'rateplan_id') !== undefined) guestInfo.rateplan_id = get('ratePlanId', 'rateplan_id')

  // Build query string with encoding
  const queryString = Object.keys(guestInfo)
    .map(key => `${key}=${encodeURIComponent(guestInfo[key])}`)
    .join('&')


  try {
    const url = `${API_URL_V1}pms/guest/search/?${queryString}`
    const { access_token } = yield call(getItems, ['access_token'])
    API_PMS_HEADERS.headers.Authorization = `Bearer ${access_token}`
    const response = yield APIGetRequest(url, API_PMS_HEADERS)

    if (response.status === 200) {
      const { items, paging } = response.data
      const dataResponse = items.map((obj, key) => ({
        key,
        id: obj.id,
        full_name: obj.full_name || "",
        sex: obj.sex || "",
        birthdate: obj.birthdate,
        age: obj.age || "",
        nationality: obj.nationality || "",
        vip_level: obj.vip_level,
        company: obj.company,
        telephones: obj.telephones,
        mobiles: obj.mobiles,
        fax: obj.fax,
        emails: obj.emails,
        member_code: obj.member_code || "",
        doc_number: obj.doc_number || "",
        visit_count: obj.visit_count || "",
        visit_nights: obj.visit_nights,
        last_arrival: obj.last_arrival,
        last_departure: obj.last_departure
      }))
      yield put(searchGuestDataSourceSuccess({ items: dataResponse, paging }))
      yield delay(100)
    } else {
      const { message, data } = response.data
      const result_code = ''
      const result_msg = isEmpty(message) ? `Error search guest ${response.status}` : `${message}  ${response.status}`
      const result_data = []
      yield put(setMsgAlertBooking({ result_code, result_msg, result_data }))
      if (response.status === 403 && data)
        yield put(userSignOut())
    }
  } catch (error) {
    const result_code = ''
    const result_msg = 'Error Call search guest'
    const result_data = []
    yield put(setMsgAlertBooking({ result_code, result_msg, result_data }))
  }
}

function* getGuestById({payload}){
  
  try {
    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/guest/${payload.id}`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const response = yield APIGetRequest(url,API_PMS_HEADERS)
    
    if(response.status === 200){
      const dataResponse = response.data
      if(payload.isMainGuest){
        yield put(getMainGuest(dataResponse))
      } else {
        yield put(getGuestProcessSuccess(dataResponse))
        yield delay(100)
      }
    }else{
      if(payload.isMainGuest){
        yield put(getMainGuest([]))
      } else {
        yield put(getGuestProcessSuccess([]))
        yield delay(100)
      }
      const {message,data} = response.data
      const result_code = ''
      const result_msg = isEmpty(message) ? `Error search guest ${response.status}`  : `${message}  ${response.status}` 
      const result_data = []
      yield put(setMsgAlertBooking({result_code, result_msg, result_data}))
      if(response.status === 403){
        /* if data is not null force signout */
        if(data)
          yield put(userSignOut())
      }
    }
  } catch (error) {
    const result_code = ''
    const result_msg = 'Error search guest' 
    const result_data = []
    yield put(setMsgAlertBooking({result_code, result_msg, result_data}))
  }

}

function* guestDetailSearchProcess({payload}){
  const {value,updateMainGuest,notiKey} = payload
  try {
    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/guest/${value}`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const response = yield APIGetRequest(url,API_PMS_HEADERS)
    
    if(response.status === 200){
      const dataResponse = response.data
      if(updateMainGuest){
        yield put(searchGuestDetailDataSourceSuccess(dataResponse))
        yield delay(100)
        const processStatus = { status: true, action: "getGuestDetail", message:"Guest data is updated",notiKey}
        yield put(searchGuestProcessSuccess(processStatus))
        yield delay(100)
      }else{
        yield put(searchGuestDetailFormDataSourceSuccess(dataResponse))
        yield delay(100)
        const processStatus = { status: true, action: "getGuestDetailForm", message:"Guest data is load success.",notiKey}
        yield put(searchGuestProcessSuccess(processStatus))
        yield delay(100)
      }
    }else{

      const {message,data} = response.data
      const processStatus = { status: false, action: "getGuestDetail", message}
      yield put(searchGuestProcessSuccess(processStatus))
      yield delay(100)
      if(response.status === 403){
        /* if data is not null force signout */
        if(data)
          yield put(userSignOut())
      }
    }
  } catch (error) {
    const processStatus = { status: false, action: "getGuestDetail", message:error}
    yield put(searchGuestProcessSuccess(processStatus))
    yield delay(100)
  }
}

function* guestUpdateProcess({ payload }) {
  const rawPayload = payload && typeof payload === 'object' ? payload : {};
  const guestData = rawPayload?.data ?? rawPayload;
  const onSuccess = rawPayload?.onSuccess;
  const onError = rawPayload?.onError;
  const guestId = guestData?.id ?? guestData?.guest_id ?? null;

  if (!guestId) {
    const message = 'guestId is required'
    yield put(updateGuestFailure({ guestId: null, message }))
    if (typeof onError === 'function') {
      try {
        yield call(onError, new Error(message))
      } catch (err) {
        // swallow callback errors
      }
    }
    return
  }

  try {
    const url = `${API_URL_V1}pms/rpc/guest/update`
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const response = yield call(APIPostRequest, url, guestData, API_PMS_HEADERS)

    if (response?.status === 200) {
      yield put(updateGuestSuccess({ guestId, data: response?.data ?? response }))
      yield delay(100)
      if (typeof onSuccess === 'function') {
        try {
          yield call(onSuccess, response)
        } catch (err) {
          // ignore callback errors
        }
      }
    } else {
      const message = response?.data?.message || 'Error update guest'
      yield put(updateGuestFailure({ guestId, status: response?.status, response, message }))
      yield delay(100)
      if (response?.status === 403 && response?.data?.data) {
        yield put(userSignOut())
      }
      if (typeof onError === 'function') {
        try {
          yield call(onError, new Error(message))
        } catch (err) {
          // ignore callback errors
        }
      }
    }
  } catch (error) {
    const message = error?.message || 'Error update guest'
    yield put(updateGuestFailure({ guestId, message, error }))
    yield delay(100)
    if (typeof onError === 'function') {
      try {
        yield call(onError, error)
      } catch (err) {
        // ignore callback errors
      }
    }
  }
}

export function* guestSearch() {
  yield takeEvery(SEARCH_GUEST_PREVIEW, guestSearchProcess)
}

export function* getGuest() {
  yield takeEvery(GET_GUEST, getGuestById)
}

export function* guestDetailSearch(){
  yield takeLatest(SEARCH_GUEST_DETAIL_REQUEST,guestDetailSearchProcess)
}

export function* guestUpdate() {
  yield takeLatest(UPDATE_GUEST_REQUEST, guestUpdateProcess)
}

function* guestCreateProcess({ payload }) {
  const rawPayload = payload && typeof payload === 'object' ? payload : {};
  const guestData = rawPayload?.data ?? rawPayload;
  const onSuccess = rawPayload?.onSuccess;
  const onError = rawPayload?.onError;

  try {
    const url = `${API_URL_V1}pms/rpc/guest/create`
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const response = yield call(APIPostRequest, url, guestData, API_PMS_HEADERS)

    if (response?.status === 200) {
      yield put(createGuestSuccess({ data: response?.data ?? response }))
      yield delay(100)
      if (typeof onSuccess === 'function') {
        try {
          yield call(onSuccess, response)
        } catch (err) {
          // ignore callback errors
        }
      }
    } else {
      const message = response?.data?.message || 'Error create guest'
      yield put(createGuestFailure({ status: response?.status, response, message }))
      yield delay(100)
      if (response?.status === 403 && response?.data?.data) {
        yield put(userSignOut())
      }
      if (typeof onError === 'function') {
        try {
          yield call(onError, new Error(message))
        } catch (err) {
          // ignore callback errors
        }
      }
    }
  } catch (error) {
    const message = error?.message || 'Error create guest'
    yield put(createGuestFailure({ message, error }))
    yield delay(100)
    if (typeof onError === 'function') {
      try {
        yield call(onError, error)
      } catch (err) {
        // ignore callback errors
      }
    }
  }
}

export function* guestCreate() {
  yield takeLatest(CREATE_GUEST_REQUEST, guestCreateProcess)
}

function* guestMergeProcess({ payload }) {
  const rawPayload = payload && typeof payload === 'object' ? payload : {};
  const mergeData = rawPayload?.data ?? rawPayload;
  const onSuccess = rawPayload?.onSuccess;
  const onError = rawPayload?.onError;

  try {
    const url = `${API_URL_V1}pms/rpc/guest/merge`
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const response = yield call(APIPostRequest, url, mergeData, API_PMS_HEADERS)

    if (response?.status === 200) {
      yield put(mergeGuestSuccess({ data: response?.data ?? response }))
      yield delay(100)
      if (typeof onSuccess === 'function') {
        try {
          yield call(onSuccess, response)
        } catch (err) {
          // ignore callback errors
        }
      }
    } else {
      const message = response?.data?.message || 'Error merge guest'
      yield put(mergeGuestFailure({ status: response?.status, response, message }))
      yield delay(100)
      if (response?.status === 403 && response?.data?.data) {
        yield put(userSignOut())
      }
      if (typeof onError === 'function') {
        try {
          yield call(onError, new Error(message))
        } catch (err) {
          // ignore callback errors
        }
      }
    }
  } catch (error) {
    const message = error?.message || 'Error merge guest'
    yield put(mergeGuestFailure({ message, error }))
    yield delay(100)
    if (typeof onError === 'function') {
      try {
        yield call(onError, error)
      } catch (err) {
        // ignore callback errors
      }
    }
  }
}

export function* guestMerge() {
  yield takeLatest(MERGE_GUEST_REQUEST, guestMergeProcess)
}

export default function* rootSaga() {
  yield all([
    fork(guestSearch),
    fork(getGuest),
    fork(guestDetailSearch),
    fork(guestUpdate),
    fork(guestCreate),
    fork(guestMerge)
  ])
}
